import { render, staticRenderFns } from "./SignUpCard.vue?vue&type=template&id=b7060984&scoped=true"
import script from "./SignUpCard.vue?vue&type=script&lang=ts"
export * from "./SignUpCard.vue?vue&type=script&lang=ts"
import style0 from "./SignUpCard.vue?vue&type=style&index=0&id=b7060984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7060984",
  null
  
)

export default component.exports